export default __webpack_public_path__ + "static/media/logo-placeholder.a30076fe.svg";